import styled from 'styled-components';

import { breakpoints } from '@soluto-private/mx-asurion-ui-react';

import { SubContainers } from './SubContainers';

const RightSectionContainerStyled = styled(SubContainers)`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: var(--pageLayoutPadding, 16px);
  margin-bottom: 80px;
  box-sizing: border-box;

  ${breakpoints.md} {
    overflow-y: auto;
    margin-bottom: 0;
    padding: var(--pageLayoutPadding, 24px);
    width: 375px;
  }

  ${breakpoints.lg} {
    padding: var(--pageLayoutPadding, 48px);
    width: 500px;
  }
`;

export type RightSectionContainerProps = {
  children?: React.ReactNode;
};

export const RightSectionContainer = ({
  children,
}: RightSectionContainerProps) => (
  <RightSectionContainerStyled tabIndex={0}>
    {children}
  </RightSectionContainerStyled>
);
